import { useQuery } from "@apollo/client";
import React, { useState } from "react";
import ProcessedEmailsTable from "./ProcessedEmailsTable";
import { DATA_FOR_FILTERS_IN_REVIEW_AND_PROCESSED_EMAILS, PROCESSED_EMAILS } from "../../api/queries";
import useTableFilters from "@/components/forms/useTableFilters";
import { VStack } from "@chakra-ui/react";
import TableFiltersForm from "../../components/forms/TableFiltersForm";
import { usePaginatedTableRequest } from '@/components/tables/hooks/usePaginatedTableRequest';

const ProcessedEmails = () => {
  const { filters, setFilters } = useTableFilters();
  const { data: dataForFilters, loading: dataForFiltersLoading } = useQuery(DATA_FOR_FILTERS_IN_REVIEW_AND_PROCESSED_EMAILS, {
    variables: {
      isFailedEmails: false
    }
  });

  const {
    data,
    pagination,
    setPagination,
    loading
  } = usePaginatedTableRequest(PROCESSED_EMAILS, filters)

  return (
    <VStack width="100%" gap={4}>
      <TableFiltersForm
        setFilters={setFilters}
        renderFilters={["businessNames", "dbas", "owners", "ssns", "processingDates"]}
        dataForFilters={dataForFilters?.dataForFiltersInReviewAndProcessedEmails}
        dataForFiltersLoading={dataForFiltersLoading}
        tableInitialLoading={loading}
      />
      <ProcessedEmailsTable 
        processedEmails={data?.processedEmail?.items} 
        pagination={pagination}
        setPagination={setPagination}
        totalCount={data?.processedEmail?.totalCount}
        loading={loading}
      />
    </VStack>
  );
};

export default ProcessedEmails;
